module.exports = __webpack_public_path__ + "img/intro2.3dc92a77.jpg";